// El pixel ID lo provee la app que monta el Layout (vía la prop
// `fbPixelId`). Lo guardamos a nivel de módulo para que `trackSubscribe`
// pueda re-inicializar con advanced matching sin que el call site
// (NewsletterPopup) tenga que pasarlo explícitamente.
let activePixelId: string | null = null;

type PixelEventData = Record<string, unknown>;

interface ScheduleTrackingData {
    contentName: string;
    source?: string;
}

export const advancedMatching = (email: string) => {
    const am: Record<string, string | null> = {
        em: email,
        ct: null,
        country: null,
        db: null,
        fn: null,
        ge: null,
        ln: null,
        ph: null,
        st: null,
        zp: null,
    };
    return am;
};

const getPixelInstance = () => {
    if (typeof window === 'undefined') {
        return {
            init: () => { },
            pageView: () => { },
            track: () => { },
            trackSingle: () => { },
            trackCustom: () => { },
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return require('react-facebook-pixel').default;
};

export const initFacebookPixel = (
    pixelId: string,
    advancedMatchingParams: Record<string, string | null> | null = null,
) => {
    activePixelId = pixelId;
    const ReactPixel = getPixelInstance();

    const fbOptions = {
        autoConfig: true,
        debug: false,
    };

    ReactPixel.init(pixelId, advancedMatchingParams, fbOptions);
    return ReactPixel;
};

export const trackPageView = () => {
    if (!activePixelId) return;
    const ReactPixel = getPixelInstance();
    ReactPixel.pageView();
};

export const trackSubscribe = (email: string, additionalData = {}) => {
    if (!activePixelId) return;
    const ReactPixel = getPixelInstance();
    const advancedMatchingParams = advancedMatching(email);

    ReactPixel.init(activePixelId, advancedMatchingParams);
    ReactPixel.track('Subscribe', { email, ...additionalData });
};

export const trackCustomEvent = (eventName: string, data: PixelEventData = {}) => {
    if (!activePixelId) return;
    const ReactPixel = getPixelInstance();
    ReactPixel.trackCustom(eventName, data);
};

export const trackEvent = (eventName: string, data: PixelEventData = {}) => {
    if (!activePixelId) return;
    const ReactPixel = getPixelInstance();
    ReactPixel.track(eventName, data);
};

export const trackSchedule = ({ contentName, source }: ScheduleTrackingData) => {
    trackEvent('Schedule', {
        content_category: 'book_a_call',
        content_name: contentName,
        ...(source ? { source } : {}),
    });
};

export const trackCaseStudyView = (caseStudySlug: string) => {
    trackEvent('ViewContent', {
        content_ids: [caseStudySlug],
        content_name: caseStudySlug,
        content_type: 'case_study',
    });
};
